const vendorData = [
  {
    id: 1,
    vendor: "Traduko AB",
    numOfContracts: "12",
    activeContract: "Y",
    totalValue: "$130,321",
  },
  {
    id: 2,
    vendor: "Entireworld Inc",
    numOfContracts: "8",
    activeContract: "N",
    totalValue: "$75,009",
  },
  {
    id: 3,
    vendor: "Nicole Adams",
    numOfContracts: "5",
    activeContract: "Y",
    totalValue: "$24,232",
  },
  {
    id: 4,
    vendor: "Deasign AB",
    numOfContracts: "2",
    activeContract: "N",
    totalValue: "$12,790",
  },
  {
    id: 5,
    vendor: "Reaggie Jackson",
    numOfContracts: "1",
    activeContract: "N",
    totalValue: "$3,759",
  },
]

export default vendorData
